/* Moon Basin Worlds - product page gallery + size guard (Simon, 2026-10-11).
   Swipe is native (CSS scroll-snap); this file only keeps the thumbnails, counter and glow in step with the
   picture in view, opens the enlarged picture, and stops ADD TO BAG without a size (Jay 2026-09-24: no size is
   ever pre-selected). No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initGallery(root) {
    var track = root.querySelector('[data-mb-pdp-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-mb-pdp-slide]'));
    var thumbsBox = root.querySelector('[data-mb-pdp-thumbs]');
    var thumbs = thumbsBox ? Array.prototype.slice.call(thumbsBox.querySelectorAll('[data-mb-pdp-go]')) : [];
    var at = root.querySelector('[data-mb-pdp-at]');
    var status = root.querySelector('[data-mb-pdp-status]');
    var current = 0;

    function setActive(i) {
      if (i === current || i < 0 || i >= slides.length) return;
      current = i;
      thumbs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-active', on);
        if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (at) at.textContent = String(i + 1);
      var label = slides[i].getAttribute('aria-label') || '';
      if (status) status.textContent = label;
      var view = (thumbs[i] && thumbs[i].getAttribute('aria-label')) || '';
      root.dataset.view = /^Show (Front|Back)$/.test(view) ? view.slice(5).toLowerCase() : 'photo';
      // keep the active thumbnail in view without moving the page
      var t = thumbs[i];
      if (t && thumbsBox) {
        var how = reduce ? 'auto' : 'smooth';
        if (thumbsBox.scrollHeight > thumbsBox.clientHeight + 1) { // desktop: vertical column
          var tp = t.offsetTop, bt = tp + t.offsetHeight;
          if (tp < thumbsBox.scrollTop) thumbsBox.scrollTo({ top: tp - 8, behavior: how });
          else if (bt > thumbsBox.scrollTop + thumbsBox.clientHeight) thumbsBox.scrollTo({ top: bt - thumbsBox.clientHeight + 8, behavior: how });
        } else { // phone: horizontal row
          var l = t.offsetLeft, r = l + t.offsetWidth; // thumbsBox is position:relative = the offsetParent
          if (l < thumbsBox.scrollLeft) thumbsBox.scrollTo({ left: l - 8, behavior: how });
          else if (r > thumbsBox.scrollLeft + thumbsBox.clientWidth) thumbsBox.scrollTo({ left: r - thumbsBox.clientWidth + 8, behavior: how });
        }
      }
    }

    function go(i) {
      var s = slides[i];
      if (!s) return;
      track.scrollTo({ left: s.offsetLeft, behavior: reduce ? 'auto' : 'smooth' }); // track is the offsetParent
      setActive(i);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio >= 0.6) setActive(Number(e.target.dataset.mbPdpSlide));
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    } else {
      track.addEventListener('scroll', function () {
        setActive(Math.round(track.scrollLeft / Math.max(1, track.clientWidth)));
      }, { passive: true });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(Number(t.dataset.mbPdpGo)); });
    });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, current + 1)); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, current - 1)); }
    });

    // Enlarged picture
    var dialog = root.querySelector('[data-mb-pdp-dialog]');
    var dimg = dialog && dialog.querySelector('[data-mb-pdp-dialog-img]');
    if (dialog && dimg && typeof dialog.showModal === 'function') {
      root.addEventListener('click', function (e) {
        var z = e.target.closest('[data-mb-pdp-zoom]');
        if (!z || !root.contains(z)) return;
        var slide = slides[Number(z.dataset.mbPdpZoom)];
        var img = slide && slide.querySelector('img');
        if (!img) return;
        e.preventDefault();
        dimg.src = img.dataset.mbPdpFull || img.currentSrc || img.src;
        dimg.alt = img.alt || '';
        dialog.showModal();
      });
      dialog.addEventListener('click', function (e) {
        if (e.target === dialog || e.target.closest('[data-mb-pdp-close]')) dialog.close();
      });
      dialog.addEventListener('close', function () { dimg.removeAttribute('src'); });
    }
  }

  function initSizes(root) {
    var form = root.querySelector('[data-mb-pdp-form]') || root.querySelector('form.mb-pdp__form');
    var box = root.querySelector('[data-mb-pdp-sizes]');
    if (!form || !box) return;
    var err = box.querySelector('[data-mb-pdp-size-error]');
    var radios = Array.prototype.slice.call(box.querySelectorAll('input[type="radio"]'));
    function showError() {
      box.classList.add('is-invalid');
      if (err) err.hidden = false;
      box.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
      var first = radios.filter(function (r) { return !r.disabled; })[0];
      if (first) first.focus({ preventScroll: true });
    }
    // native `required` fires "invalid" before submit; replace the browser bubble (it would point at a hidden input)
    radios.forEach(function (r) {
      r.addEventListener('invalid', function (e) { e.preventDefault(); showError(); });
      r.addEventListener('change', function () { box.classList.remove('is-invalid'); if (err) err.hidden = true; });
    });
    form.addEventListener('submit', function (e) {
      if (!radios.some(function (r) { return r.checked; })) { e.preventDefault(); showError(); return; }
      var btn = form.querySelector('.mb-add-to-bag');
      if (btn) btn.setAttribute('aria-busy', 'true');
    });
  }

  // Desktop: size the picture to the room actually left below where it starts (Jay 2026-10-11 "The jersey is too low").
  // The page scrolls inside .page-wrapper on desktop, so measure against that scroller, not the window.
  var wide = window.matchMedia('(min-width: 990px)');
  function fit(root) {
    var stage = root.querySelector('.mb-product__stage');
    if (!stage) return;
    if (!wide.matches) { root.style.removeProperty('--mb-fit'); return; }
    var pw = root.closest('.page-wrapper');
    var scrolled = pw && pw.scrollHeight > pw.clientHeight ? pw.scrollTop - pw.getBoundingClientRect().top : window.scrollY;
    var top = stage.getBoundingClientRect().top + scrolled;
    root.style.setProperty('--mb-fit', Math.floor(window.innerHeight - top - 24) + 'px');
  }
  // A product name never splits mid-word ("BREACHBO / RN"): if its longest word is wider than the column, shrink the
  // heading until it fits. Only ever shrinks from the stylesheet size.
  function fitTitle(root) {
    var h = root.querySelector('h1');
    if (!h) return;
    h.style.fontSize = '';
    var w = h.clientWidth;
    if (!w || h.scrollWidth <= w) return;
    h.style.fontSize = Math.floor(parseFloat(getComputedStyle(h).fontSize) * w / h.scrollWidth * 0.98) + 'px';
  }
  function fitAll() { document.querySelectorAll('[data-mb-pdp]').forEach(function (r) { fit(r); fitTitle(r); }); }

  function init() {
    document.querySelectorAll('[data-mb-pdp]').forEach(function (root) {
      if (root.dataset.mbPdpReady) return;
      root.dataset.mbPdpReady = '1';
      fit(root);
      fitTitle(root);
      initGallery(root);
      initSizes(root);
    });
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(fitAll, 120);
  });
  window.addEventListener('load', fitAll); // fonts and the header settle after DOMContentLoaded
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('.mb-pdp .mb-add-to-bag[aria-busy]').forEach(function (b) { b.removeAttribute('aria-busy'); });
  });
})();

/* Loads the two-axis colour row - assets/mb-pdp-colors.js v3 (Simon, 2026-10-25).
   It lives in its own file because themeFilesUpsert caps a GraphQL document at 16,384 characters and
   this file plus the colour code exceeds it.
   🔑 Only the FILE NAME is swapped, so this script's ?v= cache key is carried over: an unversioned
   asset URL is cached hard by the CDN and will serve a stale colour file. After editing
   mb-pdp-colors.js you MUST re-save this file too, or the old colour file keeps being served. */
(function () {
  var me = document.currentScript && document.currentScript.src;
  if (!me || me.indexOf('mb-pdp.js') === -1) return;
  var s = document.createElement('script');
  s.src = me.replace('mb-pdp.js', 'mb-pdp-colors.js');
  s.defer = true;
  document.head.appendChild(s);
})();